import { render, staticRenderFns } from "./GroupsNew.vue?vue&type=template&id=9857fe98&lang=pug&"
import script from "./GroupsNew.vue?vue&type=script&lang=ts&"
export * from "./GroupsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports